import styles from "../style/chat_call.module.css";
import { useSelector } from "react-redux";
import { chatActions } from "../../../di/di";
import { useDispatch } from "react-redux";
import { useState, useEffect, useStore, useRef } from "react";
import { VoiceCallStatus } from "../../../../domain/enum/voice_call_status";
import { StringUtils } from "../../../../../core/utils/string_utils";
import { AIMode } from "../../../../domain/enum/ai_mode";

const ChatCallComponent = () => {
  const showCall = useSelector((state) => state.chat.showCall);
  const voiceCallStatus = useSelector((state) => state.chat.voiceCallStatus);
  const voiceCallTime = useSelector((state) => state.chat.voiceCallTime);
  const aiMode = useSelector((state) => state.chat.aiMode);
  const user = useSelector((state) => state.user.user);
  const userFirstCharacter = StringUtils.getFirstCharacter(user?.name);
  const callToneAudioRef = useRef(null);

  const dispatch = useDispatch();

  const closeCall = () => {
    dispatch(chatActions.closeVoiceCall({ performEnd: true }));
  };

  useEffect(() => {
    if(callToneAudioRef.current) {
      if (voiceCallStatus === VoiceCallStatus.calling) {
        callToneAudioRef.current.play();
      } else {
        callToneAudioRef.current.pause();
      }
    }
  }, [voiceCallStatus]);

  if (!showCall) return null;

  return (
    <div className="absolute top-0 left-0 w-full h-full bg-slate-900/50 backdrop-blur-md flex flex-col justify-center items-center animate-fadeIn z-50">
      <audio
        ref={callToneAudioRef}
        src="https://storage.googleapis.com/ai-companion-81b04.firebasestorage.app/audio/call_tone_1.mp3"
        loop
        autoPlay
        style={{ display: 'none' }}
      />
      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          100% {
            transform: scale(1.5);
            opacity: 0;
          }
        }
        @keyframes ringShake {
          0%,
          100% {
            transform: rotate(0);
          }
          25% {
            transform: rotate(8deg);
          }
          50% {
            transform: rotate(0);
          }
          75% {
            transform: rotate(-8deg);
          }
        }
        .pulse-ring {
          animation: pulse var(--duration) infinite ease-out var(--delay);
        }
        .animate-ring {
          animation: ringShake 0.5s infinite;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease;
        }
      `}</style>

      <div
        className={`w-40 h-40 rounded-full p-[5px] bg-gradient-to-r from-red-800 via-red-900 to-red-950 shadow-lg shadow-red-500/40 mb-8 relative  ${
          voiceCallStatus === VoiceCallStatus.initiating ||
          voiceCallStatus === VoiceCallStatus.calling
            ? "animate-ring"
            : ""
        }`}
      >
        <div className="w-full h-full rounded-full bg-slate-950 overflow-hidden flex justify-center items-center text-white text-6xl font-bold">
          {aiMode === AIMode.speaking ||
          voiceCallStatus === VoiceCallStatus.initiating ||
          voiceCallStatus === VoiceCallStatus.calling
            ? "E"
            : userFirstCharacter}
        </div>
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="pulse-ring absolute -top-[10px] -left-[10px] -right-[10px] -bottom-[10px] rounded-full border-2 border-red-500/40"
            style={{
              "--duration": `${i * 0.5 + 1}s`,
              "--delay": `${i * 0.2}s`,
            }}
          ></div>
        ))}
      </div>

      <div className="h-3"></div>

      <h2 className="text-pink-200 mt-5 mb-10 text-2xl">
        {voiceCallStatus === VoiceCallStatus.initiating
          ? "Initiating call..."
          : voiceCallStatus === VoiceCallStatus.calling
          ? "Calling Eve..."
          : voiceCallStatus === VoiceCallStatus.ongoing
          ? voiceCallTime
          : "Call ended"}
      </h2>

      <div className="flex gap-5">
        <button
          onClick={closeCall}
          className="w-[60px] h-[60px] rounded-full bg-gradient-to-r from-red-800 via-red-900 to-red-950 border-none text-white text-2xl flex items-center justify-center cursor-pointer shadow-lg shadow-red-900/30"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default ChatCallComponent;
